import React, { useContext, useEffect, useState } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../../components/MCSSpace';
import { adminService } from '../../../services/admin.service';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import Checkbox from '@visa/vds/checkbox';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import MCSFormDisplay from '../../../components/MCSFormDisplay';
import ManageUserDetails from './ManageUserDetails';
import { ObjectMapHelper } from '../../../_helpers/ObjectMapHelper';
import { updateUserDto } from '../../../_mappings/User';
import { DateHelper } from '../../../_helpers/DateHelper';

import AdditionalEntitlements from '../Components/AdditionalEntitlements';
import { useForm } from 'react-hook-form';
import EmailRegrex from '_constants/EmailValidationRegrex';
import { AuthContext } from 'context/AuthContext';


const ManageUserDialog = (props) => {
    const userData = useContext(AuthContext);

    const {
        control,
        handleSubmit,
        reset,
        setError,
        getValues,
        setValue,
        clearErrors,
        register,
        formState: { errors },
    } = useForm();

    const [emailFormatValid, setEmailFormatValid] = useState(true);
    const [loading, setLoading] = useState(false);
    const currentUser = props.currentUser.user;

    const mapDetailToUpdateDto = () => {
        let mappedDto = ObjectMapHelper.MapDto(props.user, updateUserDto);
        return mappedDto
    }

    const toggleSubscriptionManager = () => {
        props.setSelectedUser({ ...props.user, isSubscriptionManager: !props.user.isSubscriptionManager })
    }

    const toggleSifManager = () => {
        console.log("sif", props.user.isSifManager)
        props.setSelectedUser({ ...props.user, isSifManager: !props.user.isSifManager })
    }

    const toggleLibraryManager = () => {
        props.setSelectedUser({ ...props.user, isLibraryManager: !props.user.isLibraryManager })
    }

    const toggleVisaInternalAccess = () => {
        let updatedUser = { ...props.user }
        if (props.user.hasVisaInternalExtendedAccess) {
            updatedUser.hasVstsL0 = false
        }
        updatedUser.hasVisaInternalExtendedAccess = !updatedUser.hasVisaInternalExtendedAccess
        props.setSelectedUser(updatedUser)
    }

    const toggleActive = () => {
        props.setSelectedUser({ ...props.user, active: !props.user.active })
    }

    const toggleVmidParticipation = () => {
        props.setSelectedUser({ ...props.user, isVmidParticipation: !props.user.isVmidParticipation })
    }

    const toggleVmidFileUpload = () => {
        props.setSelectedUser({ ...props.user, isVmidFileUpload: !props.user.isVmidFileUpload })
    }

    const toggleAcquirerVmid = () => {
        props.setSelectedUser({ ...props.user, isAcquirerVmid: !props.user.isAcquirerVmid })
    }

    const toggleCompanyAdmin = () => {
        props.setSelectedUser({ ...props.user, isCompanyAdmin: !props.user.isCompanyAdmin })
    }

    const toggleVstsL0 = () => {
        props.setSelectedUser({ ...props.user, hasVstsL0: !props.user.hasVstsL0 })
    }

    const handleAdminVstsEntitlementsRadioBtnChange = (e) => {
        props.setSelectedUser({ ...props.user, adminVstsEntitlement: parseInt(e.target.value) })
    }

    const toggleVstsWorkflowAdmin = () => {
        props.setSelectedUser({ ...props.user, isVstsWorkflowAdmin: !props.user.isVstsWorkflowAdmin })
    }

    const toggleHasReportingExport = () => {
        props.setSelectedUser({ ...props.user, hasReportingExport: !props.user.hasReportingExport })
    }

    const updateUserDetails = async () => {
        if (props.user.email && !EmailRegrex.validEmailFormat.test(props.user.email)) {
            setError("email", {
                type: "manual",
                message: "Please enter a valid email."
            })
            return;
        } else if (props.user.email && !EmailRegrex.coporateEmail.test(props.user.email)) {
            setError("email", {
                type: "manual",
                message: "Only business emails are allowed. Non-corporate personal email addresses are strictly prohibited."
            })
            return;
        }

        setLoading(true)
        let updateUserDto = mapDetailToUpdateDto();
        const Response = await adminService.UpdateUser(props.user.id, updateUserDto, userData.user.entitleId)
        if (Response != null && Response.status === 200) {
            props.alertObj.setSuccessMessage("User successfully updated");
        } else {
            props.alertObj.setErrorMessage("User failed to be updated: " + Response.statusText);
        }

        props.tablesRefresh();
        props.setSelectedUser(null)
        setLoading(false);
    }

    
    return (
        <>
            {loading &&
                <MCSOverlayLoading />}
            <Dialog
                aria-describedby="Edit User"
                onExit={() => { }}
                open={props.openUserAccessDialog}
                titleId="dialog-manage-user"
            >
                <DialogCardHead>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Edit User</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Row noGutter key={1}>
                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Region" data={props.user && props.user.regionName} />
                            </Col>
                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="User ID" data={props.user && props.user.volUserId} />
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={2}>
                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Country" data={props.user && props.user.organizationCountryName} />
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Role" data={props.user && props.user.roleName} />
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={3}>
                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Organization" data={props.user && props.user.organizationName} />
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="BID" data={props.user && props.user.bid} />
                            </Col>
                        </Row>

                        <ManageUserDetails setError={setError} clearErrors={clearErrors} setValue={setValue} getValues={getValues} control={control} countries={props.countries} user={props.user} setUser={props.setSelectedUser} emailFormatValid={emailFormatValid} setEmailFormatValid={setEmailFormatValid} />
                        <MCSSpace />

                        <Row noGutter >
                            <Col noTopGutter noGutter lg={6} >
                                <MCSFormDisplay labelName="Accepted By" data={props.user && props.user.createdBy} />
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Accepted On" data={props.user && DateHelper.ToLocaleDateString(props.user.createdOn)} />
                            </Col>
                        </Row>
                        <MCSSpace />


                        <Row noGutter>
                            <Col noTopGutter noGutter lg={6} >
                                <MCSFormDisplay labelName="Updated By" data={props.user && props.user.lastUpdatedBy} />
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Updated On" data={props.user && DateHelper.ToLocaleDateString(props.user.lastUpdatedOn)} />
                            </Col>
                        </Row>
                        <MCSSpace />

                        <Row noGutter>
                            <Col noTopGutter noGutter lg={6}>
                                <MCSFormDisplay labelName="Last Accessed On"
                                    data={props.user && props.user.lastAccessedOn != null ? DateHelper.ToLocaleDateString(props.user.lastAccessedOn) : "-"} />
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                            </Col>
                        </Row>

                        <Row noGutter key={5}>
                            <Col noTopGutter noGutter lg={6}>
                                <CheckboxList>
                                    <CheckboxListItem>
                                        <Checkbox
                                            checked={props.user && props.user.active} onChange={toggleActive}
                                            id={"active"} label={"Active"}
                                            name="checkbox-active"
                                        />
                                    </CheckboxListItem>
                                </CheckboxList>
                            </Col>
                            <Col noTopGutter noGutter lg={6} />
                        </Row>

                        <AdditionalEntitlements user={props.user} setUser={props.setUser} currentUser={currentUser}
                            toggleLibraryManager={toggleLibraryManager} toggleSifManager={toggleSifManager}
                            toggleSubscriptionManager={toggleSubscriptionManager} toggleVisaInternalAccess={toggleVisaInternalAccess}
                            toggleVmidParticipation={toggleVmidParticipation} toggleVmidFileUpload={toggleVmidFileUpload}
                            toggleAcquirerVmid={toggleAcquirerVmid} toggleCompanyAdmin={toggleCompanyAdmin}
                            toggleVstsL0={toggleVstsL0} handleAdminVstsEntitlementsRadioBtnChange={handleAdminVstsEntitlementsRadioBtnChange}
                            toggleVstsWorkflowAdmin={toggleVstsWorkflowAdmin} toggleHasReportingExport={toggleHasReportingExport} 
                            vstsEntitlements={props.user ? props.user.adminVstsEntitlement : null}
                        />

                        <MCSSpace />
                        <MCSSpace />

                    </Grid>
                    <MCSSpace />
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => { props.setSelectedUser(null) }}
                        >
                            Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={handleSubmit(updateUserDetails)}
                        >
                            Save
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>

    )
}


export default ManageUserDialog